export default __webpack_public_path__ + "static/media/1-sgi-ingreso-v2.5f8acb4b.png";